<template>
  <v-col :lg="4" :md="6" :sm="12" v-if="image">
    <v-card class="mx-auto" height="100%" width="100%">
      <v-img class="white--text align-end" height="275px" :src="image"> </v-img>

      <v-card-title class="article-title">{{ article.title }}</v-card-title>

      <v-card-text class="text--primary">
        <div>{{ article.contentSnippet }}</div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <a class="medium-link" :href="article.guid" target="_blank">
          <v-btn color="red" text>
            Read on Medium
          </v-btn>
        </a>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: ["article"],
  computed: {
    image() {
      let parser = new DOMParser();
      let parsedHtml = parser.parseFromString(
        this.article.content,
        "text/html"
      );
      return parsedHtml.images[0] ? parsedHtml.images[0].src : "";
    },
  },
};
</script>

<style>
.article-title {
  word-break: normal !important;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  width: 100% !important;
  padding-bottom: 5px !important;
}

.medium-link {
  color: transparent !important;
}
</style>
